import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	label: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "14px",
		marginBottom: "5px",
	},
	required: {
		color: "#E31212",
		marginLeft: "2px",
	},
}));

const FieldLabel = ({ children, required }) => {
	const { classes } = useStyles();
	return (
		<Typography className={classes.label}>
			{children}
			{required ? <span className={classes.required}>*</span> : null}
		</Typography>
	);
};

export default FieldLabel;
